import React from "react";
import { DEFAULT_TEAM_PAGE_SIZE, DEFAULT_COMPANIES_PAGE_SIZE, DEFAULT_ACCOUNTS_PAGE_SIZE, DEFAULT_COMPLAINTS_PAGE_SIZE } from "../constants/pagination";

export interface UseManagementPaginationReturn {
  // Состояния пагинации
  currentPage: number;
  totalItems: number;
  itemsPerPage: number;
  
  // Действия
  setCurrentPage: (page: number) => void;
  setTotalItems: (total: number) => void;
  
  // Утилиты
  totalPages: number;
  goToPage: (page: number) => void;
  goToNextPage: () => void;
  goToPrevPage: () => void;
  hasNextPage: boolean;
  hasPrevPage: boolean;
}

interface UseManagementPaginationOptions {
  defaultPageSize: number;
}

function createUseManagementPagination(options: UseManagementPaginationOptions): () => UseManagementPaginationReturn {
  const { defaultPageSize } = options;

  return function useManagementPaginationHook(): UseManagementPaginationReturn {
    const [currentPage, setCurrentPage] = React.useState(1);
    const [totalItems, setTotalItems] = React.useState(0);
    const itemsPerPage = defaultPageSize;

    const totalPages = Math.ceil(totalItems / itemsPerPage);
    const hasNextPage = currentPage < totalPages;
    const hasPrevPage = currentPage > 1;

    const goToPage = React.useCallback((page: number) => {
      console.log('🔍 goToPage called:', { page, totalPages, currentPage });
      if (page >= 1 && page <= totalPages) {
        console.log('🔍 Setting currentPage to:', page);
        setCurrentPage(page);
      } else {
        console.log('🔍 Page out of range:', { page, totalPages });
      }
    }, [totalPages]);

    const goToNextPage = React.useCallback(() => {
      if (hasNextPage) {
        setCurrentPage(prev => prev + 1);
      }
    }, [hasNextPage]);

    const goToPrevPage = React.useCallback(() => {
      if (hasPrevPage) {
        setCurrentPage(prev => prev - 1);
      }
    }, [hasPrevPage]);

    return {
      currentPage,
      totalItems,
      itemsPerPage,
      setCurrentPage,
      setTotalItems,
      totalPages,
      goToPage,
      goToNextPage,
      goToPrevPage,
      hasNextPage,
      hasPrevPage,
    };
  };
}

// Специализированные хуки для каждого раздела
export const useTeamPagination = createUseManagementPagination({
  defaultPageSize: DEFAULT_TEAM_PAGE_SIZE,
});

export const useCompaniesPagination = createUseManagementPagination({
  defaultPageSize: DEFAULT_COMPANIES_PAGE_SIZE,
});

export const useAccountsPagination = createUseManagementPagination({
  defaultPageSize: DEFAULT_ACCOUNTS_PAGE_SIZE,
});

export const useComplaintsPagination = createUseManagementPagination({
  defaultPageSize: DEFAULT_COMPLAINTS_PAGE_SIZE,
});
